module.exports = __webpack_public_path__ + "static/media/steam-symbol.12e79796.svg";